import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Button from 'src/components/buttons/button';
import FacebookLoginButton from 'src/modules/shared/auth/components/facebookLoginButton';
import GoogleLoginButton from 'src/modules/shared/auth/components/googleLoginButton';
import ValidatedTextInput from 'src/components/inputs/validatedTextInput';
import { Field, reduxForm } from 'redux-form';
import { required } from 'src/utils/validators';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { login } from 'src/modules/shared/auth/actions';
import { truncate } from 'underscore.string';
import i18n from 'i18next';

class LoginBox extends React.Component {
  static defaultProps = {
    onLoginSuccess: () => {},
  };

  constructor(props) {
    super(props);
  }

  onClickSignup = (event) => {
    event.preventDefault();
    this.props.showSignupModal(null, null, false, null, this.props.visitorReply, this.props.onLoginSuccess);
  }

  getFields = () => {
    return [
      {
        name: 'email',
        label: 'Email or username:',
        placeholder: i18n.t('Your email or username'),
        type: 'text',
        validate: [required(i18n.t('This field is required.'))],
        id: 'email',
      },
      {
        name: 'password',
        label: 'Password:',
        placeholder: i18n.t('Password'),
        type: 'password',
        validate: [required(i18n.t('This field is required.'))],
        id: 'password',
      },
    ];
  }

  onSubmit = async ({ email, password }) => {
    await this.props.login({ password, username: email, staySignedIn: true });
    this.props.onLoginSuccess();
  }

  render() {
    const { submitting, visitorReply } = this.props;
    const title = visitorReply && i18n.t('Log in to post your reply') || i18n.t('Welcome back!');
    const subtitleMobile = visitorReply && `"${truncate(visitorReply.body, 15)}"` || i18n.t("It's great to see you again");
    const subtitleClassName = classNames({
      'modal-subtitle': true,
      'login-box__subtitle': true,
      'hidden-xs': !visitorReply,
    });

    return <section className="login-box">
      <form role="form" onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <h2 className="signup-box__title">{title}</h2>
        <h3 className={subtitleClassName}>{subtitleMobile}</h3>
        <FacebookLoginButton
          fullWidth={true}
          text={i18n.t('Log in with Facebook')}
          onSuccess={this.props.onLoginSuccess}
        />
        <GoogleLoginButton
          fullWidth={true}
          text={i18n.t('Log in with Google')}
          onSuccess={this.props.onLoginSuccess}
        />
        <p className="signup-box__word-with-line">
          <span>{i18n.t('or')}</span>
        </p>
        <div className="login-box__fields" >
          {this.getFields().map((field, i) => <Field
            key={i}
            {...field}
            component={ValidatedTextInput}
          />)}
        </div>
        <Button
          text={i18n.t('Log in')}
          isSubmit={true}
          onClick={this.props.handleSubmit(this.onSubmit)}
          disabled={submitting}
          fullWidth={true}
        />
        <div className="signup-box__form-text">
          <a href="/reset">{i18n.t('Forgot your password?')}</a>
        </div>
        <div className="signup-box__footer">
          {i18n.t('Not a member yet?')} <a href="#" onClick={this.onClickSignup}>{i18n.t('Join')}</a>
        </div>
      </form>
    </section>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login,
    showSignupModal,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(
  reduxForm({
    form: 'login',
  })(LoginBox),
);



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/loginBox.js